import { render, staticRenderFns } from "./DeleteFilePermanently.vue?vue&type=template&id=430a8f7a&scoped=true&"
import script from "./DeleteFilePermanently.vue?vue&type=script&lang=js&"
export * from "./DeleteFilePermanently.vue?vue&type=script&lang=js&"
import style0 from "./DeleteFilePermanently.vue?vue&type=style&index=0&id=430a8f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430a8f7a",
  null
  
)

export default component.exports